export enum AppLanguage {
  Estonian = 1,
  English = 2,
  Tallink = 32,
  German = 64
}

(AppLanguage as any).__typeName = "AppLanguage";
